import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { StockApplicationPrintComponent } from '../stock-application-print/stock-application-print.component';
import { PrintService } from 'src/app/services/print.service';
import { SubmitDetail } from 'src/app/stores/submit-detail.store';
import { ActivatedRoute, Router } from '@angular/router';
import { ConvertService, pushToObject, sum, sumData, orderBy } from 'src/app/services/convert.service';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { CommentStore } from 'src/app/stores/comment.store';
import { AngularFirestore } from '@angular/fire/firestore';
import { Auth } from 'src/app/stores/auth.store';
import { statusObj } from 'src/app/dummy/status';
import { SettingStore } from 'src/app/stores/settings/setting.store';
import { FileManagerStore } from 'src/app/stores/filemanager.store';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-stock-application-detail',
  templateUrl: './stock-application-detail.component.html',
  styleUrls: ['./stock-application-detail.component.scss']
})
export class StockApplicationDetailComponent implements OnInit {
  @Input() title: string;
  @Input() data: any;
  @Input() link: string;
  @Input() backlink: string;
  @Input() collection: string;
  @Input() isHide: boolean;
  @Input() isHidePrint: boolean;
  @Input() isHideDelete: boolean;
  @Input() isRelease: boolean;
  @Input() isHideEdit: boolean;
  @Input() isDeleted: boolean;
  @Input() printTemplate: number;
  @Output() onDelete = new EventEmitter();
  @Output() onRelease = new EventEmitter();
  @Output() cancelSubmit = new EventEmitter();
  @ViewChild('content') content: ElementRef;
  @ViewChild('editor') editor;

  modules = {};
  form: FormGroup;
  formUpload: FormGroup;
  file: AbstractControl;
  comment: AbstractControl;
  selectedFiles: any;
  id;
  ismobile = false;
  auditData;
  totalQtyStock = 0
  printTemplateData;
  detailData: any;
  item: any;
  constructor(
    public ps: PrintService,
    private dialog: MatDialog,
    public detail: SubmitDetail,
    private fb: FormBuilder,
    public cm: CommentStore,
    private afs: AngularFirestore,
    public auth: Auth,
    public store: SettingStore,
    private snackBar: MatSnackBar,
    public fm: FileManagerStore,
    private router: Router,
    public breakpointObserver: BreakpointObserver,

  ) {
    this.modules = {
      syntax: false,
      toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        ['formula'],
        ['image', 'code-block']
      ]
    }
  }

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.ismobile = state.matches;
        } else {
          this.ismobile = state.matches;
        }
      });
    this.formUpload = this.fb.group({
      file: [null, Validators.required]
    });
    this.form = this.fb.group({
      comment: [null, Validators.required]
    })
    this.comment = this.form.controls['comment']
    this.file = this.form.controls['file']

    if (this.data) {
      this.item = this.data;
      this.id = this.item.key;
      this.detailData = ConvertService.orderBy(this.item.registerCoItems, 'created_at');
      this.cm.fetchCommentByCompany(this.collection, this.item.companyKey, this.item.key);
    }
  
    // if (this.printTemplate) {
    //   this.store.fetchCollectionPrintTemplate(this.auth.selectedCompany.key, Number(this.printTemplate), data => {
    //     this.printTemplateData = data
    //   })
    // }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.data?.currentValue) {
      this.item = changes.data.currentValue;
      this.id = this.item.key;
      this.detailData = ConvertService.orderBy(this.item.registerCoItems, 'created_at');
      this.cm.fetchCommentByCompany(this.collection, this.item.companyKey, this.item.key);
    }
  }

  ngOnDestroy(): void {
    if (this.cm.subscription) {
      this.cm.subscription.unsubscribe()
    }
  }
  async getItem(data) {
    const item = []
    for (const item of data) {
      const data = pushToObject(await item.registerItemRef.get())
      item.push(data)
    }
    return item;
  }

  editItem = null;
  editComment(item) {
    this.editItem = item
    this.form.patchValue({
      comment: item.comment
    })
  }

  postComment(f, data) {
    if (this.form.valid) {
      const isEdit = this.editItem ? true : false;
      const key = this.editItem ? this.editItem.key : this.afs.createId()
      const item = {
        key: key,
        refKey: data.key,
        comment: f.comment,
        created_at: this.editItem ? this.editItem.created_at : new Date(),
        created_by: this.editItem ? this.editItem.created_by : this.auth.user,
        updated_at: new Date(),
        updated_by: this.auth.user,
        status: statusObj.active,
        isEdit: isEdit,
      }
      this.cm.addCommentByCompany(this.collection, this.auth.selectedCompany.key, item, (success, res) => {
        this.editItem = null;
        this.form.reset();
      })
    }

  }

  onSelectedFile(event) {
    this.selectedFiles = event;
    this.uploadFile()
  }

  uploadFile() {
    if (this.formUpload.valid) {
      this.fm.addFileManagerByCompany(this.router.url, this.auth.selectedCompany.name_en, this.collection, this.auth.selectedCompany.key, this.id, this.auth.user, this.selectedFiles, success => { })
    }
  }
  deleteFile(file) {
    this.fm.deleteFileDataByCompany(this.auth.selectedCompany.name_en, this.collection, this.auth.selectedCompany.key, file, (success, res) => {
      if (success)
        this.snackBar.open("File has been delete successful.", "Done", { duration: 100 });
    })
  }
  print() {
    this.ps.print('#print', 'a4');
  }
  printMasterList() {
    const item = this.data
    const collection = this.collection
    const dialogRef = this.dialog.open(StockApplicationPrintComponent, {
      data: { item, collection, sqty: this.totalQtyStock, printTemplateData: this.printTemplateData },
      panelClass: 'print-master-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  delete(item: any) {
    this.onDelete.emit(item);
  }

  cancel(item: any) {
    this.cancelSubmit.emit(item);
  }
  _onRelease(item?: any){
    this.onRelease.emit(item);
  }

}
